<template>
    <section class="subpage-header">
        <ModuleSubpageMenu :module="subpageMenu" :active="subpageData.title" :activeColor="subpageData.color"></ModuleSubpageMenu>

        <div class="container">
            <div class="columns">
                <div class="column">
                    <div class="subpage__header">
                        <figure>
                            <Image :image="subpageData.image_logo" :width="166" :height="0" :isLazy="false" v-if="subpageData.image_logo"></Image>
                        </figure>
                        <h1 v-if="website && website.title" class="subpage__title">{{ subpageData.title }} - {{ website.title }}</h1> 
                        <h1 v-else class="subpage__title">{{ subpageData.title }}</h1> 
                    </div>
                </div>    
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import ModuleSubpageMenu from "../modules/ModuleSubpageMenu.vue";
import Image from "../elements/Image.vue";
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import { useMeta } from 'vue-meta'

export default {
    name: "SubpageHeader",
    components: {
        ModuleSubpageMenu,
        Image
    },
    watch: {
        '$route.path': {
            handler: function() {
                this.getSubpageMenu();
            },
            deep: true,
            immediate: true
        }
    },
    props: {
        pageId: {
            type: Number,
            required: true,
        },
        pageType: {
            type: String,
            required: true,
        },
        website: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {
            SUBPAGE_MENU: "/api/krainaabc/category?device=www&id=",
            subpageMenu: [],
            subpageData: {},
        };
    },
    methods: {
        getSubpageMenu() {
            axios.get(`${this.SUBPAGE_MENU}${this.pageId}`).then((response) => {
                if (response.status === 200) {
                    if(response.data && response.data.data) {
                        this.subpageData = response.data.data;

                        if(response.data.data.color) {
                            this.$store.dispatch("setCategoryColor", response.data.data.color);
                        }

                        if(response.data.data.menu) {
                            this.subpageMenu = response.data.data.menu;
                        }
                    }
                }
            });
        }
    },
    computed: {
        history() {
            return this.$store.getters.getHistory;
        },
    },
    mounted() {
        const store = useStore();
        let id;

        if(this.$route.params.id) {
            id = parseInt(this.$route.params.id);
        } else {
            if(this.history.some(el => el.path === this.path)) {
                id = this.history.find(el => el.path === this.path).id;
            } else {
                id = window.__pageSettings.id;
            }
        }

        store.dispatch('getMeta', { id: id });
        const metaData = computed(() => store.getters.getMetaData);
        const meta_title = ref(null);
        const meta_description = ref(null);
        const meta_keywords = ref(null);
        const meta_url = ref(null);

        watch(
            () => metaData.value,
            (newValue) => {
                if (newValue && newValue.data) {
                    meta_keywords.value = newValue.data.meta_keywords;
                    meta_title.value = newValue.data.meta_title;
                    meta_description.value = newValue.data.meta_description;
                    meta_url.value = newValue.data.url
                }
            }
        );
        
        const computedMeta = computed(() => ({
            title: meta_title.value ? meta_title.value : '',
            description: meta_description.value ? meta_description.value : '',
            link: [
                {
                    rel: 'canonical',
                    href: meta_url.value ? meta_url.value : '',
                },
            ],
            meta: [
              { property: 'keywords', content: meta_keywords.value ? meta_keywords.value : '' },
            ]
        }))

        useMeta(computedMeta);
    }
}
</script>
